// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2eNpF","footer":"ModalInfo_footer__ebuYe"};